/**
 * 預設 watchlist：
 * - 使用者公司 MSFT
 * - AI 主流（NVDA / GOOGL / META / AMD）
 * - 同事短線預選熱門股（INTC / STX / PLTR / CEG / CRWV / RKLB / ALAB）
 * - 台股 AI（2330 台積電 / 2454 聯發科 / 2317 鴻海）
 * 參考：c:\Users\huadit\source\repos\shortterm-stock-dashboard
 */
export const DEFAULT_WATCHLIST = [
    // 使用者公司
    { symbol: 'MSFT', market: 'US', name: 'Microsoft', category: '工作 ・ AI 平台', emoji: '🪟' },
    // 美股 AI 主流
    { symbol: 'NVDA', market: 'US', name: 'NVIDIA', category: 'AI 半導體', emoji: '🟢' },
    { symbol: 'GOOGL', market: 'US', name: 'Alphabet', category: 'AI 平台', emoji: '🔍' },
    { symbol: 'META', market: 'US', name: 'Meta', category: 'AI 平台', emoji: '🟦' },
    { symbol: 'AMD', market: 'US', name: 'AMD', category: 'AI 半導體', emoji: '🔴' },
    // 同事短線預選 — 熱門
    { symbol: 'INTC', market: 'US', name: 'Intel', category: '半導體 ・ 短線', emoji: '🔵' },
    { symbol: 'PLTR', market: 'US', name: 'Palantir', category: 'AI 數據', emoji: '⚙️' },
    { symbol: 'CEG', market: 'US', name: 'Constellation', category: '核能 ・ AI 用電', emoji: '⚡' },
    { symbol: 'CRWV', market: 'US', name: 'CoreWeave', category: 'AI 雲算力', emoji: '☁️' },
    { symbol: 'RKLB', market: 'US', name: 'Rocket Lab', category: '太空', emoji: '🚀' },
    // 台股 AI
    { symbol: '2330.TW', market: 'TW', name: '台積電', category: '晶圓代工', emoji: '🟧' },
    { symbol: '2454.TW', market: 'TW', name: '聯發科', category: 'IC 設計', emoji: '🟪' },
    { symbol: '2317.TW', market: 'TW', name: '鴻海', category: 'AI 伺服器', emoji: '🟨' },
    { symbol: '2382.TW', market: 'TW', name: '廣達', category: 'AI 伺服器龍頭', emoji: '🖥' },
    { symbol: '3231.TW', market: 'TW', name: '緯創', category: 'AI 伺服器', emoji: '🌐' },
    { symbol: '6669.TW', market: 'TW', name: '緯穎', category: 'CSP AI server', emoji: '☁️' },
    { symbol: '2308.TW', market: 'TW', name: '台達電', category: 'AI 電源', emoji: '⚡' },
];
//# sourceMappingURL=watchlist.js.map